import { Modal, ModalConfig } from '.';

export function isModalConfig(modal: Modal): modal is ModalConfig {
  return (modal as ModalConfig).modalType !== undefined;
}
